<template>
  <card-modal :visible="true" :title="title" :showPreview="false" :disableOk="false">
    <div id="modal-edit-content" class="content" v-bind:class="[showPreview ? 'is-hidden' : '']">
      
      <div class="columns">
        <div class="column is-12">
          <label class="label">Video <span class="font-weight-light">(1920x1080px .mp4)</span></label>
          <figure v-if="coachVideo" class="image fake-dropzone-video">
            <video width="100%" height="100%" controls>
              <source :src="screensaverLocation + coachVideo" type="video/mp4">
              Your browser does not support the video tag.
            </video>
            <a class="dz-remove" @click="showDropzone">Remover</a>
          </figure>
          <p v-if="!coachVideo" class="control">
            <dropzone id="coachVideoDz"
                      class="marginless-dropzone dz-dom"
                      :url="dropzoneUploadUrl"
                      v-bind:thumbnail-width="286"
                      v-bind:thumbnail-height="161"
                      v-on:vdropzone-success="successUploadVideo"
                      v-on:vdropzone-removedfile="removeVideo"
                      acceptedFileTypes=".mp4"
            ></dropzone>
          </p>
        </div>
      </div>
    </div>

  </card-modal>
</template>

<script>
import CardModal from '../Util/CardModal'
import Dropzone from '../Util/DropzoneForm'
import { API_ROOT, COACH_SAVER_PATH } from '../../config'

export default {
  components: {
    CardModal,
    Dropzone
  },

  props: {
    title: String,
    coach: String,
    video: String
  },

  data () {
    return {
      screensaverLocation: COACH_SAVER_PATH,
      newVideo: false,
      coachVideo: this.video,
      showPreview: false
    }
  },

  beforeDestroy () {
    let trash = document.body.querySelectorAll('.dz-hidden-input')
    for (let t of trash) {
      t.remove()
    }
  },

  mounted () {
  },

  computed: {
    currentEvent () {
      return window.store.state.event.nextEvent
    },

    userToken () {
      return window.store.state.auth.token
    },

    dropzoneUploadUrl () {
      return API_ROOT + 'resource/coach/upload/screensaver?token=' + this.userToken
    },

    submitIsActive () {
      return false
    }
  },

  methods: {
    successUploadVideo (file) {
      this.coachVideo = JSON.parse(file.xhr.response).file
    },

    removeVideo () {
      console.log('A file was been removed')
      this.coachVideo = null
    },

    showDropzone () {
      this.newVideo = true
      this.removeVideo()
    }
  },

  watch: {
    currentEvent: function (val) {
      if (val === 'modal-card-close') {
        this.$destroy()
      }
      if (val === 'modal-card-ok') {
        window.store.dispatch('updateCoachScreensaver', { id: this.coach, data: {file: this.coachVideo} })
      }
      if (val === 'modal-card-preview') {
        // no preview
      }
      if (val === 'modal-card-cancel') {
        window.store.dispatch('newEvent', 'modal-card-close')
      }
    },

    submitIsActive: function (val) {
      if (val) {
        document.querySelector('.card-modal-ok-btn').classList.remove('is-disabled')
      } else {
        document.querySelector('.card-modal-ok-btn').classList.add('is-disabled')
      }
    }
  }
}
</script>

<style>
  @import url('~dropzone/dist/dropzone.css');
  @import 'https://fonts.googleapis.com/css?family=Roboto';

  .is-hidden {
    display: none !important;
  }

  #coachVideoDz {
    height: 165px;
    display: flex;
  }

  #coachVideoDz.dropzone .dz-preview .dz-error-message {
    top: 90px;
    left: 73px;
  }

  #coachVideoDz.dropzone .dz-message {
    margin: 4em auto;
  }

  .content #coachVideoDz a:not(.button):hover {
    border-bottom-color: inherit;
  }

  .fake-dropzone-video {
    border: 1px solid #dbdbdb;
    border-radius: 3px;
    line-height: 0;
  }

  .fake-dropzone-video .dz-remove {
    font-family: 'Roboto', sans-serif;
    color: #777;
    position: absolute;
    z-index: 30;
    color: white;
    margin-left: 15px;
    padding: 10px;
    top: inherit;
    bottom: 50px;
    border: 2px white solid;
    text-decoration: none;
    text-transform: uppercase;
    font-size: 0.8rem;
    font-weight: 800;
    letter-spacing: 1.1px;
    opacity: 0;
    text-align: center;
    display: block;
    cursor: pointer;
    background-color: rgba(37, 148, 139, 0.8);
    line-height: initial;
  }

  .fake-dropzone-video:hover .dz-remove {
    opacity: 1;
  }

  .fake-dropzone-video a:not(.button) {
    border-bottom: 2px white solid !important;
  }

  .fake-dropzone-video a:not(.button):hover, .content #coachVideoDz a:not(.button):hover {
    border-bottom-color: inherit !important;
  }
</style>



// WEBPACK FOOTER //
// CoachScreensaverModal.vue?2279e66d